import { useSelector, useDispatch } from 'react-redux';
import * as lessonSelectors from '../selectors';
import * as lessonActions from '../actions';
import { useEffect } from 'react';
import { STATUS } from '../constants';

export const useQuizAttempts = (lessonId, questionId = null) => {
  const dispatch = useDispatch();

  const quizAttempts = useSelector((state) =>
    questionId
      ? lessonSelectors.getQuizAttemptsByQuestionId(state, questionId)
      : lessonSelectors.getQuizAttemptsByLessonId(state, lessonId)
  );

  const quizAttemptsLoadingStatus = useSelector((state) =>
    lessonSelectors.getQuizAttemptsByLessonIdStatus(state, lessonId)
  );

  useEffect(() => {
    if (quizAttemptsLoadingStatus === STATUS.UNINITIALIZED) {
      dispatch(lessonActions.loadQuizAttemptsByLessonId.signal(lessonId));
    }
  }, [dispatch, lessonId, quizAttemptsLoadingStatus]);

  return {
    data: quizAttempts,
    isLoading: [STATUS.LOADING, STATUS.SUBMITTING].includes(
      quizAttemptsLoadingStatus
    ),
    error:
      quizAttemptsLoadingStatus === STATUS.ERROR
        ? 'Error loading Quiz Attempts'
        : null,
    save: (lessonId, questionId, quizAttempt, callback, onError) =>
      dispatch(
        lessonActions.saveQuizAttempt.signal(
          lessonId,
          questionId,
          quizAttempt,
          callback,
          onError
        )
      ),
  };
};
